import { FunctionComponent } from "react";

import RxPageLayout from "@/components/ui/display/RxPageLayout";
import AboutHeader from "@/components/marketing/about/AboutHeader";
import FoundedContent from "@/components/marketing/about/FoundedContent";
import BreakBar from "@/components/marketing/about/BreakBar";
import WeDoThisContent from "@/components/marketing/about/WeDoThisContent";
import AsSeenInContent from "@/components/marketing/home/AsSeenInContent";

const About: FunctionComponent = () => {
  return (
    <RxPageLayout>
      <AboutHeader />
      <FoundedContent />
      <BreakBar />
      <WeDoThisContent />
      <AsSeenInContent />
    </RxPageLayout>
  );
};

export default About;
